import { ToastService } from "../../components/toast/toast.service";
import { Component, ViewChild, OnInit } from "@angular/core";
import {
  style,
  state,
  animate,
  transition,
  trigger,
} from "@angular/animations";
import { PopoverContent, PopoverModule } from "ngx-popover";
import { AuthService, UserPermissions } from "../../services/auth.service";
import { EditDisplayNameComponent } from "./edit-display-name-modal.component";
import { ChangePasswordComponent } from "./change-password-modal.component";
import { PatientService } from "../../services/patient.service";
import { Router } from "@angular/router";
import { Role } from "../../models/role.enum";
import { SearchService } from "../../services/search.service";
import { ManageSecondaryPatientIdsComponent } from "./manage-secondary-ids.component";
import { BulkAddTagsModalComponent } from "../bulk-add-tags/bulk-add-tags-modal.component";

@Component({
  selector: "lowy-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  providers: [AuthService, PatientService],
  animations: [
    trigger("fadeInOut", [
      transition(":enter", [
        style({ width: "20px", opacity: 0 }),
        animate("250ms ease-in", style({ width: "200px", opacity: 1 })),
      ]),
      transition(":leave", [
        animate("250ms ease-out", style({ width: "20px", opacity: 0 })),
      ]),
    ]),
  ],
})
export class HeaderComponent implements OnInit {
  public userPermissions: UserPermissions;
  settingsPopoverList: Array<{
    title: string;
    callback: Function;
  }>;

  settingsPopoverIsOpen: boolean;
  showSearchBar: boolean;
  showOriginalSearchIcon: boolean;
  searchPatientId: string;

  public startingRoute: string;

  @ViewChild("settingsPopover") settingsPopover: PopoverContent;
  @ViewChild("editDisplayNameModal")
  editDisplayNameModal: EditDisplayNameComponent;
  @ViewChild("changePasswordModal")
  changePasswordModal: ChangePasswordComponent;
  @ViewChild("manageSecondaryPatientIdsModal")
  manageSecondaryPatientIdsModal: ManageSecondaryPatientIdsComponent;
  @ViewChild("bulkAddTagsModal") bulkAddTagsModal: BulkAddTagsModalComponent;

  constructor(
    private authService: AuthService,
    private toastService: ToastService,
    private patientService: PatientService,
    private router: Router,
    private searchService: SearchService
  ) {}

  async ngOnInit() {
    this.authService.permissions$.subscribe((permissions) => {
      this.userPermissions = permissions;
      if (permissions.adminManageTags) {
        this.settingsPopoverList.unshift({
          title: "Manage Seach Tags",
          callback: () => {
            this.manageSearchTags();
          },
        });
        this.settingsPopoverList.unshift({
          title: "Bulk Add Search Tags",
          callback: () => {
            this.bulkAddSearchTags();
          },
        });
      }
      if (permissions.adminManageUsers) {
        this.settingsPopoverList.unshift({
          title: "Manage Users",
          callback: () => {
            this.manageUsers();
          },
        });
        this.settingsPopoverList.unshift({
          title: "Manage Secondary IDs",
          callback: () => {
            this.manageSecondaryPatientIds();
          },
        });
      }
    });

    this.settingsPopoverList = [
      {
        title: "View Data Dictionary",
        callback: () => {
          this.router.navigate(["/dataDictionary"]);
        },
      },
      {
        title: "Edit display name",
        callback: () => {
          this.editDisplayName();
        },
      },
      {
        title: "Change password",
        callback: () => {
          this.changePassword();
        },
      },
      {
        title: "Log out",
        callback: () => {
          this.searchService.clearSearch();
          this.authService.logout();
        },
      },
    ];

    this.showSearchBar = false;
    this.showOriginalSearchIcon = true;
    this.searchPatientId = "";

    this.startingRoute = await this.authService.getStartingRoute();
  }

  settingsPopoverClick() {
    // awkward workaround because the onShown emitter below doesn't fire on the very first open since settingsPopover.popover doesn't exist
    if (typeof this.settingsPopoverIsOpen === "undefined") {
      this.settingsPopoverIsOpen = true;
    }

    const onShownSubscription = this.settingsPopover.popover.onShown.subscribe(
      () => {
        this.settingsPopoverIsOpen = true;
        onShownSubscription.unsubscribe();
      }
    );
    const onHiddenSubscription =
      this.settingsPopover.popover.onHidden.subscribe(() => {
        this.settingsPopoverIsOpen = false;
        onHiddenSubscription.unsubscribe();
      });
  }

  editDisplayName() {
    this.editDisplayNameModal.open();
  }

  changePassword() {
    this.changePasswordModal.open();
  }

  manageUsers() {
    this.router.navigate(["/admin/manageUsers"]);
  }

  manageSecondaryPatientIds() {
    this.manageSecondaryPatientIdsModal.open();
  }

  manageSearchTags() {
    this.router.navigate(["/admin/searchTags"]);
  }

  bulkAddSearchTags() {
    this.bulkAddTagsModal.open();
  }

  async doSearch() {
    const patId = this.searchPatientId;
    const patient = await this.patientService.getPatient(patId);
    if (!patient) {
      this.toastService.throwToast("Patient not found: " + patId);
      return;
    }
    this.doHideSearchBar();
    this.router.navigate(["/data", "patient", patId]);
  }

  doHideSearchBar() {
    this.showSearchBar = false;
    this.searchPatientId = "";
    setTimeout(() => {
      this.showOriginalSearchIcon = true;
    }, 250);
  }

  doShowSearchBar() {
    this.showSearchBar = true;
    this.showOriginalSearchIcon = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/home/header/header.component.ts